import LnerStopsDot from "./LnerStopsDot";

export default LnerStopsDot;
